<template>
  <div>
    <BasicModal
      :title="'シナリオ編集記録'"
      :isShowModal="isShowModal"
      :canCancel="true"
      @cancel="cancel">
      <div class="action-container disp-scroll">
        <table class="sended-list-table" border="1" v-if="scenarioEditStats.length > 0">
          <tr class="table-header">
            <th class="item">編集者</th>
            <th class="item">時間(分)</th>
          </tr>
          <template v-for="(editor, i) in scenarioEditStats[0].editors">
            <tr :key="i">
              <td>{{editor.name}}</td>
              <td class="item">{{Math.round(editor.time_sec * 100 / 60) / 100}}</td>
            </tr>
          </template>
          <tr>
            <td><b>総計</b></td>
            <td class="item">{{Math.round(scenarioEditStats[0].total_time_sec * 100 / 60) / 100}}</td>
          </tr>
        </table>
      </div>
      <!-- フッターアクション -->
      <div class="footer-box">
        <button class="button" @click="cancel">閉じる</button>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    chatbot: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioEditStats']),
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.action-container {
  padding: 16px;
  height: 500px;
  overflow: auto;
  h2 {
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    text-align: left;
    margin-bottom: 16px;
  }
  button {
    width: 47%;
  }
}

.sended-list-table {
  font-size: 12px;
  width: 100%;
  table-layout: fixed;
  th, td {
    padding: 8px;
  }
  .item {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailScenarioEditStats.vue